import * as requestFromServer from "./GradeAndSectionReportCrud";
import { callTypes, gradeAndSectionReportSlice } from "./GradeAndSectionReportSlice";

const {actions} = gradeAndSectionReportSlice;

export const getGradeAndSectionReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getGradeAndSectionReport(queryParams)
    .then(response => {
      dispatch(actions.gradeAndSectionReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllGradeAndSectionReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllGradeAndSectionReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanGradeAndSectionReportState = () => dispatch => {
  dispatch(actions.gradeAndSectionReportStateCleaned());
}